<app-admin-list-page [title]="'Student profiles' | translate">

  <div slot="filters" class="view-filters card mb-3">

    <div class="card-header d-flex">

      <div class="dropdown flex-grow-1">

        <button class="btn btn-outline-secondary ml-0 mr-2 dropdown-toggle" (click)="filterOpen = !filterOpen">
          {{'Filters' | translate}}
        </button>

        <div id="filterDropdown" [class.d-none]="!filterOpen">

          <div id="view-filter-panels" class="view-filter-panels card-body">

            <div class="row">

              <div class="col-12 col-sm-6">

                <h4>{{'General' | translate}}</h4>

                <div class="form-group">
                  <label>{{ 'Sort on' | translate }}</label>
                  <div class="row">
                    <div class="col-8">
                      <select [(ngModel)]="view.filters.queryParams.SortField" class="form-control">
                        <option value="createdOn">{{ 'Date' | translate }}</option>
                        <option value="firstName">{{ 'First name' | translate }}</option>
                        <option value="lastName">{{ 'Last name' | translate }}</option>
                      </select>
                    </div>
                    <div class="col-4">
                      <select [(ngModel)]="view.filters.queryParams.SortType" class="form-control">
                        <option value="Ascending">A-Z</option>
                        <option value="Descending">Z-A</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label>{{'Search' | translate}}</label>
                  <input class="form-control" placeholder="{{ 'Email, name etc.' | translate }}" [(ngModel)]="view.filters.queryParams.SearchTerm" (change)="reloadData()"/>
                </div>

                <div class="form-group">
                  <label>{{'Education' | translate}}</label>
                  <input class="form-control"  [(ngModel)]="view.filters.queryParams.EducationSearchTerm" (change)="reloadData()"/>
                </div>

                <div class="form-group">
                  <label>{{'Reference code' | translate}}</label>
                  <input class="form-control"  [(ngModel)]="view.filters.queryParams.ReferenceCode" (change)="reloadData()"/>
                </div>

                <div class="form-group">
                  <label>{{'Profile type' | translate}}</label>
                  <select class="form-control" [(ngModel)]="view.filters.queryParams.ProfileType" (change)="reloadData()">
                    <option></option>
                    <option [value]="profileType.value" *ngFor="let profileType of view.filterOptions.profileTypes">
                      {{ profileType.name | translate }}
                    </option>
                  </select>
                </div>

                <div class="form-group">
                  <label>{{'Looking for' | translate}}</label>
                  <select class="form-control" [(ngModel)]="view.filters.queryParams.LookingFor" (change)="reloadData()">
                    <option></option>
                    <option [value]="lookingFor.value" *ngFor="let lookingFor of view.filterOptions.lookingFor">
                      {{ lookingFor.name | translate }}
                    </option>
                  </select>
                </div>

                <div class="form-group">
                  <label>{{'Location' | translate}}</label>
                  <input class="form-control"
                         ngx-gp-autocomplete
                         #placesRef="ngx-places"
                         [value]="view.filters.queryParams['Address.City'] || ''"
                         [placeholder]="'City' | translate"
                         (onAddressChange)="onLocationAddressChange($event)"
                         (input)="onLocationInput($any($event.target).value)"/>
                </div>

                <div class="form-group">
                  <label>{{'Radius' | translate}} (km)</label>
                  <select class="form-control"
                          [(ngModel)]="view.filters.queryParams.MaximumDistance"
                          (change)="reloadData()">
                    <option [ngValue]="null">{{'Any distance' | translate}}</option>
                    <option *ngFor="let km of view.filterOptions.radiusOptions" [ngValue]="km">
                      {{ km }} km
                    </option>
                  </select>
                </div>

              </div>

              <div class="col-12 col-sm-6">

                <h4>{{'Match criteria' | translate}}</h4>

                <app-filter-panel [title]="'Field of interest'" type="checkbox" [options]="view.filterOptions.areaOfInterests" [(value)]="view.filters.queryParams.AreaOfInterests" (valueChange)="reloadData()"></app-filter-panel>

                <div class="form-group">
                  <label>{{'Tags' | translate}}</label>
                  <app-tag-input
                    [suggestions]="tagSuggestions()"
                    [allowCreate]="false"
                    [placeholder]="'Filter by tag'"
                    [ngModel]="view.filters.queryParams.Tags"
                    (ngModelChange)="view.filters.queryParams.Tags = $event; reloadData()"
                  ></app-tag-input>
                </div>

              </div>

            </div>


          </div>

          <div class="d-flex justify-content-between">
            <button class="btn btn-outline-danger ml-0" (click)="resetFilters()">
              {{'Reset filters' | translate}}
            </button>

            <button class="btn btn-outline-primary ml-0" (click)="applyFilters()">
              {{'Apply filters' | translate}}
            </button>
          </div>

        </div>

      </div>

    </div>

  </div>

  <h3>{{'Results' | translate}}</h3>
  <app-table [config]="configTable" (buttonEvent)="handleButtonEvent($event)"></app-table>

</app-admin-list-page>
